import React, { useState, useEffect } from 'react';
import CustomPagination from '../../common/Pagination';
import Axios from '../../../services/AxiosInstance';
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";
import { Modal, Button, Row, Col, Container, Table } from "react-bootstrap";
import { makeStyles } from '@mui/styles';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
const useStyles = makeStyles((theme) => ({
  backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#348cd4',
  },
}));
const BuyContactsRequest = () => {
  const Navigate = useNavigate();
  const classes = useStyles();
  const [loader, setLoader] = useState({ isOpen: false, isData: '' });
  const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' });
  const [totalPages, setTotalPage] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE);
  const [requestList, setRequestList] = useState([]);
  const [showFilePopup, setShowDataPopup] = useState(false);
  const [popupIndex, setPopupIndex] = useState('');

  const getBuyContactsRequests = async () => {
    Axios.get(`api/admin/get-request-buy-contacts-list?pageNo=${pageNum}&perPage=${perPage}`)
      .then((res) => {
        console.log(res);
        setRequestList(res.data.data.data);
        setTotalPage(res.data.data.totalPage);
      })
      .catch((error) => {
        console.log(error);
      })
  }

  useEffect(() => {
    getBuyContactsRequests();
  }, [pageNum, perPage])


  const handleClose = () => {
    setShowDataPopup(false);
  }
  const handleOpen = (index) => {
    setPopupIndex(index)
    setShowDataPopup(true);
  }

  const showRequestlist = requestList.map((item, index) => {
    return (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.user_name}</td>
        <td>{item.business_name}</td>
        <td>{item.mobile_no}</td>
        <td>{new Date(item.added_date).toDateString()}</td>
        <td>{item.status}</td>
        <td><button onClick={() => handleOpen(index)}>Details</button></td>
        <td>{item.status == 'Pending' ? <button onClick={() => handleActivate(index)}>Activate</button> : 'Activated'}</td>
      </tr>
    )
  })

  const handleActivate = (index) => {
    console.log(requestList[index]);
    Navigate(`/insert-contacts-payment?business_id=${requestList[index].business_id}&business_name=${requestList[index].business_name}&request_id=${requestList[index].request_id}`)
    // setShowDataPopup(false);
    // Axios.post(`api/admin/activate-buy-contacts?request_id=${request_id}`, setLoader({ isOpen: true }))
    //   .then((res) => {
    //     console.log(res.data);
    //     getBuyContactsRequests();
    //     setLoader({ isOpen: false });
    //     setNotify({
    //       isOpen: true,
    //       messsage: `${res.data.message}`,
    //       type: 'success',
    //     })
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setLoader({ isOpen: false });
    //     setNotify({
    //       isOpen: true,
    //       messsage: `${err.response.data.message}`,
    //       type: 'error'
    //     })
    //   })
  }

  return (
    <>
      <div className="content-page">
        <div className="content">

          <div className="container-fluid">

            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title">Request For Buy More Contacts</h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="tble-row table-responsive">
                  <table id="datatable" className="table table-bordered business_tb  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>User Name</th>
                        <th>Business Name</th>
                        <th>Mobile No</th>
                        <th>Added Date</th>
                        <th>Status</th>
                        {/* <th>District Contacts Info</th> */}
                        <th>View More</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {showRequestlist}
                    </tbody>
                  </table>

                  <CustomPagination pageNum={pageNum} setPageNum={setPageNum} totalPage={totalPages} />
                  {/* <ReactPaginate
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    // onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                  /> */}
                  <div className="slect-pg-row">
                    <span><b>Rows per page :- </b></span>
                    <select name="Rows per page"
                      className="item-page"
                      onChange={(e) => setPerpage(e.target.value)}
                    >
                      <option value="">Select Item Per Page</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                    </select>
                  </div>

                </div>
              </div>
            </div>
            {/* <!-- end row --> */}
          </div>
          {/* <!-- end container-fluid --> */}
          <Modal size="xl" aria-labelledby="contained-modal-title-vcenter"
            right show={showFilePopup}>

            <Modal.Header>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </Modal.Header>

            <Modal.Body>
              <Container>
                <Row>
                  <Col xs={6} md={4}>
                    Request ID : {requestList[popupIndex]?.request_id}
                  </Col>
                  <Col xs={6} md={4}>
                    User Name : {requestList[popupIndex]?.user_name}
                  </Col>
                  <Col xs={6} md={4}>
                    Business Name : {requestList[popupIndex]?.business_name}
                  </Col>
                  <Col xs={6} md={4}>
                    Business ID : {requestList[popupIndex]?.business_id}
                  </Col>
                  <Col xs={6} md={4}>
                    Mobile No : {requestList[popupIndex]?.mobile_no}
                  </Col>
                  <Col xs={6} md={4}>
                    New Group : {requestList[popupIndex]?.new_group}
                  </Col>
                  <Col xs={6} md={4}>
                    Existing Group : {requestList[popupIndex]?.selected_group?.group_name}
                  </Col>
                  <Col xs={6} md={4}>
                    Existing Group Id : {requestList[popupIndex]?.selected_group?.group_id}
                  </Col>
                  <Col xs={6} md={4}>
                    Added Date : {requestList[popupIndex]?.added_date}
                  </Col>
                  <Col xs={6} md={4}>
                    Status : {requestList[popupIndex]?.status}
                  </Col>
                  <Col xs={6} md={4}>
                    Country : {requestList[popupIndex]?.country_name}
                  </Col>
                  <Col xs={6} md={4}>
                    state : {requestList[popupIndex]?.state_name}
                  </Col>
                  <Col xs={6} md={4}>
                    district : {requestList[popupIndex]?.state_name}
                  </Col>
                  <Col xs={6} md={4}>
                    Total Contacts : {requestList[popupIndex]?.total_contacts}
                  </Col>
                  <Col xs={6} md={4}>
                    Gender : {requestList[popupIndex]?.gender}
                  </Col>
                  <Col xs={6} md={4}>
                    Total Cost : {requestList[popupIndex]?.total_cost}
                  </Col>
                </Row>
                <Container>
                  District Info
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>District Name</th>
                        <th>Total Contacts</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        requestList[popupIndex]?.district_contacts_info.map((item, index) =>
                          <tr key={index}>
                            <td>
                              {index + 1}
                            </td>
                            <td>
                              {item.label}
                            </td>
                            <td>
                              {item.contacts_num}
                            </td>
                          </tr>
                        )
                      }
                    </tbody>
                  </Table>
                </Container>
              </Container>
            </Modal.Body>
            {
              requestList[popupIndex]?.status == 'Pending' ?
                <Modal.Footer>
                  <Button type="button" data-dismiss="modal" aria-label="Close" onClick={() => handleActivate(popupIndex)}>
                    <span aria-hidden="true">Activate</span>
                  </Button>
                </Modal.Footer>
                : requestList[popupIndex]?.status == 'Active' ? <Button variant="outline-success">Activated</Button> : ''
            }

          </Modal>

        </div>
        {
          notify.isOpen ?
            <Notification
              notify={notify}
              setNotify={setNotify} />
            : ""
        }

        {loader.isOpen ?
          <Backdrop className={classes.backdrop} open>
            <CircularProgress color="inherit" />
          </Backdrop>
          : ""}
      </div>

      {/* <!-- end content --> */}

    </>
  )
}

export default BuyContactsRequest